import axiosHttp from "services/axiosHttp";
import moment from "moment";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchRewardOrderTickets = createAsyncThunk(
  "fetchRewardOrderTickets",
  async ({ filters, page, limit, channelId, date_filter }, { rejectWithValue }) => {
    let start_date = "";
      let end_date = "";
    
      if (filters?.range?.length === 2) {
        start_date = moment(filters.range[0].$d).format("YYYY-MM-DD");
        end_date = moment(filters.range[1].$d).format("YYYY-MM-DD");
      }

    const params = new URLSearchParams({
      page: page,
      limit: limit,
      status: filters?.status_id ?? "",
      date_from: start_date,
      date_to: end_date,
      channel: channelId ?? "",
      keyword: filters?.search || "",
      tickets: filters?.tickets || "",
    });

    if (date_filter) {
      params.append("date_filter", date_filter);
    }

    try {
      const response = await axiosHttp.get(`orders/tickets?${params}`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Something went wrong");
    }
  }
);

const RewardOrderTicketSlice = createSlice({
  name: "RewardOrderTicketSlice",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
    page: 1,
    total: 0,
  },

  extraReducers: (builder) => {
    builder.addCase(fetchRewardOrderTickets.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(fetchRewardOrderTickets.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.page = action.payload.currentPage;
      state.total = action.payload.totalOrdersCount;
    });

    builder.addCase(fetchRewardOrderTickets.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default RewardOrderTicketSlice.reducer;